import React from "react";

const DawaPrint = ({
  Datee,
  Namemowakell,
  Sefamo,
  NameKhesm,
  Mahkamaa,
  SefaKhesm,
  TypeDawa,
  NumberDawa,
  Year,
  SummaryDawa,
  Nots,
  DawaEnded,
  Numbercircle,
  Typecircle,
  TakadyDegree,
  Mawdodawa,
}) => {
  return (
    <>
      <div id="printt">
        <h3 className="text-center m-3">بيانات الدعوى</h3>

        <p>
          <span>التاريخ: </span>
          {new Date(Datee).toLocaleDateString("en-GB")}
        </p>
        <p>
          <span>اسم الموكل: </span>
          {Namemowakell.map((i) => (
            <p>{i.Name} </p>
          ))}
        </p>
        <p>
          <span>صفة الموكل بالدعوى: </span>
          {Sefamo}
        </p>
        <p>
          <span>اسم الخصم: </span>
          {NameKhesm.map((i) => (
            <p>{i.Name} </p>
          ))}
        </p>
        <p>
          <span>صفة الخصم بالدعوى: </span>
          {SefaKhesm}
        </p>
        <div className="d-flex ">
          <p style={{ marginLeft: "10px" }}>
            <span>نوع الدعوى: </span>
            {TypeDawa}
          </p>
          <p style={{ marginLeft: "10px" }}>
            <span>رقم الدعوى: </span>
            {NumberDawa}
          </p>
          <p style={{ marginLeft: "10px" }}>
            <span>السنة: </span>
            {Year}
          </p>
        </div>
        <div className="d-flex ">
          {" "}
          <p style={{ marginLeft: "10px" }}>
            <span>موضوع الدعوى: </span>
            {Mawdodawa}
          </p>
          <p style={{ marginLeft: "10px" }}>
            <span>درجة التقاضي: </span>
            {TakadyDegree}
          </p>
        </div>
        <div className="d-flex ">
          <p style={{ marginLeft: "10px" }}>
            <span>المحكمة: </span>
            {Mahkamaa}
          </p>
          <p style={{ marginLeft: "10px" }}>
            <span>نوع الدائرة: </span>
            {Typecircle}
          </p>
          <p style={{ marginLeft: "10px" }}>
            <span>رقم الدائرة: </span>
            {Numbercircle}
          </p>
        </div>
        <p>
          <span>ملخص الدعوى: </span>
          {SummaryDawa}
        </p>
        <p>
          <span>ملاحظات: </span>
          {Nots}
        </p>
        <p>
          <span>حالة الدعوى: </span>
          {DawaEnded ? "منتهية" : "مستمرة"}
        </p>
      </div>
    </>
  );
};

export default DawaPrint;
